import { loadStripe } from "@stripe/stripe-js";

/**
 * Initialize and retrieve Stripe instance
 * Handles both React and Next.js environment variable formats
 */
export const getStripe = () => {
  // Get Stripe API key from environment variables
  const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 
                         process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;
  
  if (!publishableKey) {
    console.error("Stripe publishable key is missing in environment variables");
    return null;
  }
  
  try {
    return loadStripe(publishableKey);
  } catch (error) {
    console.error("Error initializing Stripe:", error);
    return null;
  }
};

/**
 * Check if Stripe is properly configured
 */
export const isStripeConfigured = () => {
  return !!(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 
           process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY);
}; 